import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsNl from 'locales/nl/translation.json';
import translationsEn from 'locales/en/translation.json';
import translationsDk from 'locales/dk/translation.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
	nl: {
		translation: translationsNl,
	},
	en: {
		translation: translationsEn
	},
	dk: {
		translation: translationsDk
	}
};

i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.use(LanguageDetector) // detect user language
	.init({
		resources,
  		supportedLngs: ['nl', 'en', 'dk'],
		fallbackLng: 'en', // use en if detected lng is not available
		// lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
		// you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
		// if you're using a language detector, do not define the lng option

		interpolation: {
			escapeValue: false, // react already safes from xss
		},
	});

export default i18n;
